
import React, { Component } from 'react';
import './BlockSkills.css';


class BlockSkills extends Component {
  render() {

  //  const {user} = this.props;


    return (
        <div className="logo-list">     
        <h3 className="logo-list__heading">Jeg har erfaring indenfor mange teknologier:</h3>    
        <ul>
          <li className="logo-list__adobe" data-speech-bubble="Adobe står bag mange toneangivende apps - bl.a. Photoshop, Illustrator, Premiere Pro og After Effects."></li>
          <li className="logo-list__html" data-speech-bubble="HTML er et kodesprog, der er beregnet til at bygge indhold på websider."></li>
          <li className="logo-list__css3" data-speech-bubble="CSS er et kodesprog, der er beregnet til at designe indhold på websider."></li>
          <li className="logo-list__svg" data-speech-bubble="."></li>
          <li className="logo-list__jquery" data-speech-bubble="."></li>
          <li className="logo-list__js" data-speech-bubble="JavaScript er et programmeringssprog, der er beregnet til at skabe interaktion på websider, som fx klik, træk og slip."></li>
          <li className="logo-list__json" data-speech-bubble="."></li>
          <li className="logo-list__react" data-speech-bubble="React er et JavaScript library, der er beregnet til at bygge avancerede brugerflader."></li>
          <li className="logo-list__firebase" data-speech-bubble="."></li>
          <li className="logo-list__webpack" data-speech-bubble="."></li>
          <li className="logo-list__npm" data-speech-bubble="."></li>
          <li className="logo-list__node" data-speech-bubble="Node.js er et full-stack programmeringsmiljø baseret på JavaScript. Indeholder bl.a. NPM og andre udviklerværktøjer."></li>       
          <li className="logo-list__wordpress" data-speech-bubble="."></li>
          <li className="logo-list__drupal" data-speech-bubble="."></li>
          <li className="logo-list__github" data-speech-bubble="."></li>
          <li className="logo-list__php" data-speech-bubble="PHP er et populært open-source programmeringssprog beregnet til at bygge databasedrevne websider."></li>
     
        </ul>
      </div>
        
    );
  }
}

export default BlockSkills;




